import React from "react";
import { C } from "../constants.js";

export function SweepStat({ label, value, color }) {
  return React.createElement("div", null,
    React.createElement("div", {
      style: { fontSize: "11px", color: C.textMuted, fontWeight: 600,
               textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "4px" },
    }, label),
    React.createElement("div", {
      style: { fontSize: "26px", fontWeight: 700, color: color || C.navy, lineHeight: 1 },
    }, value),
  );
}


